let statement = function(id, idcus) {
	this.$router.push("statement/" + id + "/" + idcus + "");
};
export default statement;
